import React, { FunctionComponent, useEffect, useState } from "react"

import CatchPhraseBlue from "../images/cp-blue.png"
import CatchPhraseYellow from "../images/cp-yellow.png"
import CatchPhraseRed from "../images/cp-red.png"
import CatchPhrasePurple from "../images/cp-purple.png"
import CatchPhraseOrange from "../images/cp-orange.png"
import CatchPhraseGreen from "../images/cp-green.png"
import {
  handleMouseDownEvent,
  handleMouseUpEvent,
} from "../utils/buttonClickScaleEffect"
import ColorSelector from "./ColorSelector"
import { generateRandomNumber } from "../utils/generateRandomNumber"

interface CatchPhraseSectionProps {
  customCatchPhraseElements?: any
}

// Todo: Move Css to new file Media and normal
// Cleanup needed change object to array
const catchElements: any = {
  0: {
    bg: "var(--theme-orange)",
    phrase: (
      <>
        on thu<span className="salt-txt">r</span>sday, we don’t do b
        <span className="salt-txt">ooo</span>ring
      </>
    ),
    "btn-Txt": <>Be unboring</>,
    "btn-class": "btn-orangeTxt",
  },
  1: {
    bg: "var(--theme-green)",
    phrase: (
      <>
        grass is greener on thu<span className="salt-txt">r</span>sday
      </>
    ),
    "btn-Txt": <>Fertilize your grass</>,
    "btn-class": "btn-greenTxt",
  },
  2: {
    bg: "var(--theme-purple)",
    phrase: (
      <>
        For zoomers who hate to z<span className="salt-txt">ooo</span>m
      </>
    ),
    "btn-Txt": <>Stop zoooming</>,
    "btn-class": "btn-purpleTxt",
  },
  3: {
    bg: "var(--theme-yellow)",
    phrase: (
      <>
        we have a new <span className="salt-txt">favourite</span> day
      </>
    ),
    "btn-Txt": <>What’s yours?</>,
    "btn-class": "btn-yellowTxt",
  },

  4: {
    bg: "var(--theme-red)",
    phrase: (
      <>
        thu<span className="salt-txt">r</span>sday &#62; friday, no questions
      </>
    ),
    "btn-Txt": <>Change our mind</>,
    "btn-class": "btn-redTxt",
  },

  5: {
    bg: "var(--theme-lightBlue)",
    phrase: <>R.I.P friday, you served us well </>,
    "btn-Txt": <>Send your condolences</>,
    "btn-class": "btn-lightBlueTxt",
  },
}

const CatchPhraseSection: FunctionComponent<CatchPhraseSectionProps> = ({
  customCatchPhraseElements,
}) => {
  const [catchPhraseIndex, setCatchPhraseIndex] = useState<number>(0)
  const [catchPhraseSectionInfo, setCatchPhraseSectionInfo] =
    useState(catchElements)

  useEffect(() => {
    const randomNumber = generateRandomNumber({ max: 5, min: 0 })
    setCatchPhraseIndex(randomNumber)

    if (customCatchPhraseElements) {
      setCatchPhraseSectionInfo(customCatchPhraseElements)
    }
  }, [])

  const catchPhraseBtnClick = () => {
    const nextSectionIndex =
      catchPhraseIndex === Object.values(catchPhraseSectionInfo).length - 1
        ? 0
        : catchPhraseIndex + 1

    setCatchPhraseIndex(nextSectionIndex)
  }

  return (
    <>
      {" "}
      <div
        className="catchPhrase-section"
        style={{
          background: `${catchPhraseSectionInfo?.[`${catchPhraseIndex}`]?.bg}`,
        }}
      >
        <img
          className="background-blue-banner"
          src={CatchPhraseBlue}
          alt="background-blue-banner"
        />

        <img
          className="background-yellow-banner"
          src={CatchPhraseYellow}
          alt="background-yellow-banner"
        />

        <img
          className="background-red-banner"
          src={CatchPhraseRed}
          alt="background-red-banner"
        />

        <img
          className="background-purple-banner"
          src={CatchPhrasePurple}
          alt="background-purple-banner"
        />

        <img
          className="background-orange-banner"
          src={CatchPhraseOrange}
          alt="background-orange-banner"
        />

        <img
          className="background-green-banner"
          src={CatchPhraseGreen}
          alt="background-green-banner"
        />

        <div className="catchPhrase h1Text">
          {catchPhraseSectionInfo?.[`${catchPhraseIndex}`]?.phrase}
        </div>

        <button
          onClick={catchPhraseBtnClick}
          onMouseDown={handleMouseDownEvent}
          onMouseUp={handleMouseUpEvent}
          className={
            "theme-btn " +
            catchPhraseSectionInfo?.[`${catchPhraseIndex}`]?.["btn-class"]
          }
        >
          {catchPhraseSectionInfo?.[`${catchPhraseIndex}`]?.["btn-Txt"]}
        </button>
      </div>
      <ColorSelector clickHandler={setCatchPhraseIndex} />
    </>
  )
}

export default CatchPhraseSection
